import { useEffect } from 'react';

import { useApiProviderProfileModuleStateCreate } from '@rover/rsdk/src/apiClient/latest/api-provider-profile-module-state-create';

/**
 * Marks a hub module slug as started, independent of whichever module a page
 * actually loads its data from. Gated on `enabled` so a page never marks a
 * slug started before it can guarantee that slug will also be completed.
 */
const useMarkModuleStarted = (moduleSlug: string, enabled = true): void => {
  const { mutate } = useApiProviderProfileModuleStateCreate();

  useEffect(() => {
    if (!enabled) return;

    mutate({
      moduleSlug,
      data: { started: true, completed: false, optionalFieldsSet: false },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [moduleSlug, enabled]);
};

export default useMarkModuleStarted;
